import { atomFamily } from 'jotai-family';
import { atomWithDefault, loadable } from 'jotai/utils';
import { NoteComment } from '../../data-models/note.data-model';
import { fetchCommentsByNoteId } from '../queries/MaggieNoteCommentsQueries';

type NoteCommentsValue = NoteComment[] | Promise<NoteComment[]>;

/**
 * The default fetches all comments for the given note. Returns `[]` (without
 * fetching) when `noteId <= 0` — both consumers (`LexicalEditorCommentsTab`
 * and `LexicalFooter`) default `noteId` to `0` when no note is loaded yet,
 * and the API returns 404 for `noteId=0`.
 *
 * Consumers using `useAtomValue` will suspend on first read; callers that
 * cannot suspend (e.g. the `LexicalFooter` count badge) should use
 * `noteCommentsStateLoadableJ` below.
 */
export const noteCommentsStateJ = atomFamily((noteId: number) =>
  atomWithDefault<NoteCommentsValue>(async () => {
    if (noteId <= 0) {
      return [];
    }
    return fetchCommentsByNoteId(noteId);
  })
);

export const noteCommentsStateLoadableJ = atomFamily((noteId: number) =>
  loadable(noteCommentsStateJ(noteId))
);
